export const BLANK_GEOJSON_SOURCE = 'blank-geojson-source';
export const GEOJSON_SOURCE = 'geojson-source';
export const GEOJSON_SHAPE_SOURCE = 'geojson-shape-source';
export const DRAWING_SOURCE = 'drawing-source';
export const GEOLOCATION_SOURCE = 'geolocation-source';
